//#region src/utils/resolveClipDuration.ts
function e(e, t) {
	return e.duration_seconds && e.duration_seconds > 0 ? e.duration_seconds : t;
}
//#endregion
export { e as resolveClipDuration };
